import { Modal, Collapse, Alert, Dropdown } from 'bootstrap/dist/js/bootstrap.esm'

import CollapseReference from "./components/CollapseReference";
CollapseReference();

import ModalLocket from "./components/ModalLocket";
ModalLocket();

import Planner from "./components/Planner";
Planner();

import swiperWithBox from "./components/swiperWithBox";
swiperWithBox();

import InitSwiper from "./components/InitSwiper";
var defaultSwiper =  {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper__btn--next',
    prevEl: '.swiper__btn--prev',
  },

};
InitSwiper('.js--swiper', defaultSwiper);

import ContactMapInit from "./components/ContactMap";
const mapElem = document.getElementById('contact-map');
if ( mapElem ) {
  ContactMapInit('contact-map')
}

const initModal = ( id ) => {
  var myModalEl = document.getElementById(id)
  if ( myModalEl ) {
    var modal = new Modal(myModalEl)
    modal.show()
  }
}

const dropdowns = document.querySelectorAll('.dropdown-toggle')
.forEach(dropdownToggleNode => new Dropdown(dropdownToggleNode));

window.initModal = initModal;
